import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {BoardProject} from '../../../../../class/lifeproject/board-project';
import {RetirementJobCategory} from '../../../../../class/lifeproject/retirement/retirement-job-category';
import {ApiService} from '../../../../../service/api.service';
import {AniaRetirementResponse} from '../../../../../class/lifeproject/retirement/ania/response/retirement/ania-retirement-response';
import {WelfareResultService} from '../../../../../service/welfare-result.service';
import {PersonKind} from '../../../../../class/person-kind.enum';
import {formatDate} from '@angular/common';
import {NbSelectComponent} from '@nebular/theme';

@Component({
  selector: 'app-advance-retirement',
  templateUrl: './advance-retirement.component.html',
  styleUrls: ['./advance-retirement.component.css']
})
export class AdvanceRetirementComponent implements OnInit {

  @Input()
  project: BoardProject;

  @ViewChild('categoryCombo')
  categorySelection: NbSelectComponent;

  showGAPEditor: boolean;

  private _categories: RetirementJobCategory[];
  private _includeFamily: boolean;

  constructor(private apiService: ApiService, private welfareService: WelfareResultService) {
  }

  get categories(): RetirementJobCategory[] {
    return this._categories;
  }

  set categories(value: RetirementJobCategory[]) {
    this._categories = value;
  }

  set includeFamily(value: boolean) {
    this._includeFamily = value;
  }

  get includeFamily(): boolean {
    return this._includeFamily;
  }

  get aniaResponse(): AniaRetirementResponse {
    if (this.project) {
      return this.project.aniaResponse;
    }
    return null;
  }

  set aniaResponse(value: AniaRetirementResponse) {
    this.project.aniaResponse = value;
  }

  ngOnInit(): void {
    this.apiService.getAniaJobCategories().subscribe(value => {
      this.categories = value;
    });
    if (this.project.personRetirement && this.project.personRetirement.expectedMoney > 0) {
      this.showGAPEditor = true;
    }
  }

  get person() {
    if (this.project && this.project.personRetirement) {
      return this.project.personRetirement.person;
    }
    return null;
  }

  getResults() {
    this.apiService.getAniaResults(this.project).subscribe(value => {
      this.aniaResponse = value;
    });
  }

  updateIncludeFamily(value: boolean) {
    this.project.conjugated = value;

    if (value) {
      this.welfareService.persons.forEach(value1 => {
        if (value1.kind == PersonKind.CHILD) {
          this.project.childNumber += 1;
        }
      });
    } else {
      this.project.childNumber = 0;
    }
  }

  showGapEditor() {
    // get always first resutl for the moment
    const result = this.aniaResponse.simulazionePensione;
    const dataAsSting = '01/' + result.mese + '/' + result.anno;

    // clean up date for compatibility
    const date: Date = new Date(dataAsSting);

    // reformat date
    this.project.personRetirement.retirementDate = formatDate(date, 'dd/MM/yyyy', 'en-US', null);

    this.showGAPEditor = true;

  }

}
